export default __webpack_public_path__ + "static/media/OPD_CARD_BLANK_2.02842e9c.png";